import * as React from "react";
import axios from "axios";
import { useContext, useRef, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { validatePhone, getCountryFlag, handlePhoneChangeHelper } from '../../../utils/phoneValidation';
import { HotelOurContext } from "../../../context/our-hotel";
import {
  Wrapper,
  Card,
  CardDiv,
  CardWrap,
  CaRd,
  Butto,
  Count,
  Countdiv,
  DivCard,
  CardDiV,
  CaRD,
  TimeDiv,
  Succsess,
} from "./styled-index";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";

function ReservHome() {
  const [count, setCount] = useState(0);
  const [countBaby, setCountBaby] = useState(0);
  const checkin = useRef();
  const checkout = useRef();
  const number = useRef();
  const email = useRef();
  const { t, i18n } = useTranslation();
  
  // Phone validation state
  const [phoneNumber, setPhoneNumber] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const HendelChange = (e) => {
    const selectVal = e.target.value;
    window.localStorage.setItem("roomVal", selectVal);
  };
  const { HotelOurMap } = useContext(HotelOurContext);
  const Icrement = () => {
    setCount((count) => (count += 1));
  };
  const Dicrement = () => {
    setCount((count) => (count -= 1));
  };
  const Icrement2 = () => {
    setCountBaby((count) => (count += 1));
  };
  const Dicrement2 = () => {
    setCountBaby((count) => (count -= 1));
  };
  
  // Phone validation handlers
  const handlePhoneChange = useCallback((e) => {
    const value = handlePhoneChangeHelper(e.target.value);
    setPhoneNumber(value);
    if (phoneError) {
      setPhoneError('');
    }
  }, [phoneError]);

  const handlePhoneBlur = useCallback(() => {
    const error = validatePhone(phoneNumber, t);
    setPhoneError(error);
  }, [phoneNumber, t]);

  const handlePhoneFocus = useCallback(() => {
    if (!phoneNumber) {
      setPhoneNumber('+');
    }
  }, [phoneNumber]);
  const HendelCheck = async (e) => {
    e.preventDefault();
    
    // Validate phone before submission
    const phoneValidationError = validatePhone(phoneNumber, t);
    if (phoneValidationError) {
      setPhoneError(phoneValidationError);
      return;
    }
    
    try {
      const body = {
        phoneNumber: phoneNumber,
        going_time: checkout.current.value,
        come_time: checkin.current.value,
        older: count,
        child: countBaby,
        rooms_size: 1,
        lang: i18n.language || 'uz',
        site: 'rever'
      };
      const response = await axios.post(
        "/v1/api/order",
        body
      );
      if (response.data) {
        setOpen(true);
        console.log(response.data)
      }
    } catch (error) {
      console.log(error);
    }
  };
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [input, setInput] = useState(false);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  return (
    <Wrapper id="reserv">
      <h2>{t("Reserv.0")}</h2>
      <CardWrap>
        <CardDiv>
          <Card>
            <TimeDiv>
              <p>{t("Reserv.1")}</p>
              <i className="bx bxs-calendar-edit"></i>
            </TimeDiv>
            {input ? (
              <>
                <input type="date" ref={checkin} />
              </>
            ) : (
              <input
                type="text"
                onFocus={() => setInput(true)}
                placeholder={t("Reserv.10")}
              />
            )}
          </Card>
          <Card>
            <TimeDiv>
              <p>{t("Reserv.2")}</p>
              <i className="bx bxs-calendar-edit"></i>
            </TimeDiv>
            {input ? (
              <>
                <input type="date" ref={checkout} />
              </>
            ) : (
              <input
                type="text"
                onFocus={() => setInput(true)}
                placeholder={t("Reserv.10")}
              />
            )}
          </Card>
          <Card>
            <CardDiV>
              <p>{t("Reserv.3")}</p>
              <i class="bx bxs-user-check"></i>
            </CardDiV>
            <Count>
              <Countdiv>
                <p>{t("Reserv.7")}</p>
                <div>
                  <button onClick={Dicrement}><i class='bx bx-minus' ></i></button>
                  <p>{count}</p>
                  <button onClick={Icrement}><i class='bx bx-plus'></i></button>
                </div>
              </Countdiv>
              <Countdiv>
                <p>{t("Reserv.8")}</p>
                <div>
                  <button onClick={Dicrement2}><i class='bx bx-minus' ></i></button>
                  <p>{countBaby}</p>
                  <button onClick={Icrement2}><i class='bx bx-plus'></i></button>
                </div>
              </Countdiv>
            </Count>
          </Card>
        </CardDiv>
        <DivCard>
          <CaRd>
            <div>
              <p>{t("Reserv.4")}</p>
              <i class="bx bxs-hotel"></i>
            </div>
            <select onChange={HendelChange}>
              {HotelOurMap.map((elem, index) => (
                <option key={index} value={elem.title_room}>
                  {elem.title_room}
                </option>
              ))}
            </select>
          </CaRd>
          <CaRD>
            <p>{t("Reserv.5")}</p>
            <div style={{position: 'relative', width: '75%'}}>
              <input
                type="tel"
                value={phoneNumber}
                onChange={handlePhoneChange}
                onBlur={handlePhoneBlur}
                onFocus={handlePhoneFocus}
                placeholder="+998 90 123 45 67"
                maxLength={20}
                style={phoneError ? {
                  borderColor: '#dc3545',
                  paddingRight: '45px',
                  marginTop: '15%',
                  border: '1px solid #dc3545',
                  backgroundColor: '#1b1b1c',
                  width: '100%',
                  padding: '7px 10px',
                  color: 'white',
                  outline: 'none',
                  fontSize: '15px',
                  borderRadius: '5px'
                } : {
                  marginTop: '15%',
                  border: '1px solid #1b1b1c',
                  backgroundColor: '#1b1b1c',
                  width: '100%',
                  padding: '7px 10px',
                  paddingRight: '45px',
                  color: 'white',
                  outline: 'none',
                  fontSize: '15px',
                  borderRadius: '5px'
                }}
              />
              {phoneNumber && phoneNumber.length > 1 && (
                <span style={{
                  position: 'absolute',
                  right: 'calc(-45px)',
                  top: '68%',
                  transform: 'translateY(-50%)',
                  fontSize: '20px',
                  pointerEvents: 'none'
                }}>
                  {getCountryFlag(phoneNumber)}
                </span>
              )}
            </div>
            {phoneError && (
              <span style={{
                color: '#dc3545',
                fontSize: '12px',
                marginTop: '5px',
                display: 'block'
              }}>
                {phoneError}
              </span>
            )}
          </CaRD>
          <CaRD>
            <p>{t("Reserv.11")}</p>
            <input
              type="email"
              placeholder={t("Reserv.11")}
              ref={email}
            />
          </CaRD>
        </DivCard>
      </CardWrap>
      <Butto onClick={HendelCheck}>{t("Reserv.6")}</Butto>
      <div>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              <Succsess>
                <i class="bx bx-check-circle"></i>
                <h3>{t("Reserv.9")}</h3>
                <p>{t("Reserv.12")}</p>
                <button onClick={handleClose}>Ok</button>
              </Succsess>
            </Typography>
          </Box>
        </Modal>
      </div>
    </Wrapper>
  );
}
export default ReservHome;
